<footer id="footer">
  <div class="footer-container">
    <div class="footer-col footer-col-1">
      <h3 class="footer-title">{{'FOOTER.CONTACT' | translate}}</h3>
      <div class="footer-info">
        <div class="footer-info-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 20 16" fill="none">
            <path d="M2 2L8.10764 6.61227L8.10967 6.61396C8.78785 7.11128 9.12714 7.3601 9.49876 7.45621C9.82723 7.54117 10.1725 7.54117 10.501 7.45621C10.8729 7.36001 11.2132 7.11047 11.8926 6.61227C11.8926 6.61227 15.8101 3.60594 18 2M1 11.8002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40973 1.71547 1.71547 1.40973 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H15.8002C16.9203 1 17.4796 1 17.9074 1.21799C18.2837 1.40973 18.5905 1.71547 18.7822 2.0918C19 2.5192 19 3.07899 19 4.19691V11.8036C19 12.9215 19 13.4805 18.7822 13.9079C18.5905 14.2842 18.2837 14.5905 17.9074 14.7822C17.48 15 16.921 15 15.8031 15H4.19691C3.07899 15 2.5192 15 2.0918 14.7822C1.71547 14.5905 1.40973 14.2842 1.21799 13.9079C1 13.4801 1 12.9203 1 11.8002Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="footer-info-item">{{'FOOTER.INFO_EMAIL' | translate}} <span class="lighter">{{'COMMON.CONTACT_MAIL' | translate}}</span></p>
        </div>
      </div>
      <img class="footer-logo" src="img/logo/ulaznice-hr-logo.png" alt="Logo">
    </div>

    <div class="footer-col footer-col-2">
      <h3 class="footer-title">{{'FOOTER.LINKS' | translate}}</h3>
      <div class="footer-links">
        <a routerLink="/terms-of-sale">{{'FOOTER.TERMS_OF_SALE' | translate}}</a>
        <a routerLink="/privacy-policy">{{'FOOTER.PRIVACY_POLICY' | translate}}</a>
        <a [href]="officialWebsiteUrl" target="_blank">{{'FOOTER.WEBSITE' | translate}}</a>
        <a href="https://nk-rijeka.hr/klub/clanstvo/" target="_blank">{{ 'MEMBERSHIP.CLUB_MEMBERS' | translate }}</a>
      </div>
    </div>

    <div class="footer-col footer-col-3">
      <h3 class="footer-title">{{'FOOTER.ADDITIONAL_OPTIONS' | translate}}</h3>
      <div class="footer-links">
        <button type="button" class="language-button" (click)="languageService.switchLanguage(languageService.currentLanguage() === languageEnum.HR ? languageEnum.EN : languageEnum.HR)">
          <p>{{'FOOTER.LANG_VERSION' | translate}}</p>
          <ng-container *ngIf="languageService.currentLanguage() === languageEnum.EN; else enSvg">
            <img src="img/languages/Cro.svg" alt="Cro">
          </ng-container>
          <ng-template #enSvg>
            <img src="img/languages/Eng.svg" alt="Eng">
          </ng-template>
        </button>
        <a routerLink="/buy-membership" *ngIf="appConfig.appHasMembership && !userHasMembership && !becomingMemberDisabled">{{'FOOTER.BECOME_MEMBER' | translate}}</a>
        <button
          (click)="services.logout()"
          *ngIf="isAuth"
          >{{'COMMON.LOGOUT' | translate}}
        </button>
      </div>
    </div>
  </div>
</footer>
